import { Component, type ErrorInfo, type ReactNode } from 'react'
import { RefreshCw } from 'lucide-react'

export class ErrorBoundary extends Component<{ children: ReactNode; label?: string }, { failed: boolean }> {
  state = { failed: false }
  static getDerivedStateFromError() { return { failed: true } }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('Linkme screen error', error, info.componentStack) }
  render() {
    if (this.state.failed) return <main className="public-missing"><h1>This screen needs another try.</h1><p>Your data is safe. Refresh to reload {this.props.label ?? 'Linkme'}.</p><button className="button" onClick={() => location.reload()}><RefreshCw size={17} /> Refresh</button></main>
    return this.props.children
  }
}
